// extracted by mini-css-extract-plugin
module.exports = {"termContainer":"search_termContainer__1ROrE","searchBar":"search_searchBar__2Qkyu"};